/*------------------------------------------------
// File Name:PDM_SMS.js
// File Description:PDM_SMS store方法
// Author:zxl
// Create Time:2022/12/05 18:07:17
//------------------------------------------------*/

import {
    GetPDM_SMSList,
    GetPDM_SMSListByPage,
    GetPDM_SMSEntity,
    CreatePDM_SMSEntity,
    UpdatePDM_SMSEntity,
    DeletePDM_SMSEntity,
} from '@/api/pdm/sms'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmSms = {
    namespaced: true,
    state: {
        PdmSmsList: [],
        PdmSmsListLoading: false,
        PdmSmsEntity: null,
        PdmSmsShowDlg: false,
    },
    mutations: {
        setPdmSmsList(state, dataList) {
            state.PdmSmsList = [...dataList]
        },
        setPdmSmsListLoading(state, visible) {
            state.PdmSmsListLoading = visible
        },
        setPdmSmsShowDlg(state, visible) {
            state.PdmSmsShowDlg = visible
        },
        setPdmSmsEntity(state, entity) {
            state.PdmSmsEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmSms({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_SMSEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmSmsEntity', res.Data)
                        commit('setPdmSmsShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmSmsEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmSmsListLoading', true)
                GetPDM_SMSEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmSmsEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmSmsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmSmsList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmSmsListLoading', true)
                GetPDM_SMSList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmSmsList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmSmsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmSmsListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmSmsListLoading', true)
                GetPDM_SMSListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmSmsList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmSmsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmSms({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_SMSEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmSmsShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_SMS
        actEditPdmSmsData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmSmsID : entity.PdmSmsID
                }
                GetPDM_SMSEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmSmsEntity', res.Data)
                        commit('setPdmSmsShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_SMS ,传对象过来
        actEditPdmSms({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmSmsEntity', entity)
                commit('setPdmSmsShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_SMS
        actDeletePdmSms({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_SMSEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmSmsShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


